let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Hqfa")).then(() => parcelRequire('c8xJx'));